import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Contexts/authContext';
import { useTranslation } from 'react-i18next';
import Layout from './Layout';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { i18n } = useTranslation();
  const lang = i18n.language || localStorage.getItem('selectedLanguage') || 'en';

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#fff' }}>Carregando...</div>;
  }

  // Se não houver usuário logado, redireciona para a home com o idioma correto
  if (!user) {
    return <Navigate to={`/${lang}`} replace />;
  }

  // Verifica subscrição — 'free' e 'active' têm acesso
  console.log('[ProtectedRoute] user.subscriptionStatus:', user.subscriptionStatus, '| Full user:', JSON.stringify(user));
  if (user.subscriptionStatus !== 'active' && user.subscriptionStatus !== 'free') {
    console.warn('[ProtectedRoute] Access Denied: Inactive Subscription - status was:', user.subscriptionStatus);
    return <Navigate to={`/${lang}/pricing`} replace />;
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;